export const maybeNumber = (value: string | undefined | null) => {
  const numeric = !value ? undefined : parseFloat(value)

  return Number.isNaN(numeric) ? undefined : numeric
}
